import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
export default class {
    constructor(endpoint, viewTitle) {
        this.endpoint = endpoint;
        this.viewTitle = viewTitle;
        this.state = {
            loading: false,
            all: {},
            selected: {}
        };
        this.getters = {};
        this.actions = {
            getList({ commit }, param) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        commit("setLoading", { loading: true });
                        request_list(endpoint, data => {
                            commit('setList', data);
                            resolve(data);
                            commit("setLoading", { loading: false });
                        }, Vue.http, param, this.state.authentication.token);
                    }, 100)
                });
            },
            getDetail({ commit }, id) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        commit("setLoading", { loading: true });
                        request_detail(endpoint, data => {
                            commit('setDetail', data);
                            commit("setLoading", { loading: false });
                            resolve(data.data)
                        }, Vue.http, id, this.state.authentication.token);
                    }, 100)
                })
            },
            setDetail({ commit }, { data, id }) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (id > 0) {
                            update_detail(endpoint, res => {
                                if (res.data.status === 'fail') {
                                    sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                                    reject(res);
                                }
                                else {
                                    sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`)
                                    refreshResource();
                                    resolve(res);
                                }
                            }, Vue.http, data, id, this.state.authentication.token);
                        }
                        else {
                            delete data.id;
                            create_detail(endpoint, res => {
                                if (res.data.status === 'fail') {
                                    sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                                    reject(res);
                                }
                                else {
                                    sendSuccessNotice(`Thêm mới ${viewTitle} thành công.`);
                                    refreshResource();
                                    resolve(res);
                                }
                            }, Vue.http, data, this.state.authentication.token);
                        }
                    }, 100)
                })
            },
            removeDetail({ commit }, id) {
                commit("setLoading", { loading: true });
                remove_detail(endpoint, res => {
                    if (res.data.status === false) {
                        sendErrorNotice(`Không thể xóa ${viewTitle}.`)
                    }
                    else {
                        sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
                        refreshResource();
                    }
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }
        };
        this.mutations = {
            setList(state, data) {
                state.all = data;
            },
            setDetail(state, item) {
                state.selected = item.data ? item.data : item;
            },
            setLoading(state, { loading }) {
                state.loading = loading;
            }
        };
    }
}